import React, { useState, useEffect } from "react";
import { Card, CardTitle, Row, Col } from "reactstrap";
import ReactTable from "react-table";
import { connect } from 'react-redux';
import BackButton from "../../../../designUtils/Logo/BackButton.svg";
import FetchAmazonNotificationLogsService from "../../../../Service/DashboardServices/AmazonNotificationsServices/FetchAmazonNotificationLogsService";

function AmazonNotificationsMainPage(props) {

    const [isLoading, setIsLoading] = useState(false);
    const [notificationData, setNotificationData] = useState([]);
    const [search, setSearch] = useState("");
    const [expandedPayload, setExpandedPayload] = useState({});

    useEffect(() => {
      fetchAmazonNotifications();
  }, []);
  
  const fetchAmazonNotifications = () => {
      setIsLoading(true);
      FetchAmazonNotificationLogsService(props.token).then((response) => {
  
              if (response && response.status) {
                  setNotificationData(response.notificationList);
              }
              setIsLoading(false);
          });
  };

  const filteredNotificationData = notificationData.filter((row) =>
    Object.values(row || {}).some((value) =>
        String(
            typeof value === "object"
                ? JSON.stringify(value)
                : value || ""
        )
            .toLowerCase()
            .includes(search.toLowerCase())
    )
);

    const columns = [
        {
            Header: "ID",
            accessor: "id",
            width: 70,
        },
        {
            Header: "Notification ID",
            accessor: "notificationID",
            minWidth: 180,
        },
        {
            Header: "Notification Type",
            accessor: "notificationType",
            minWidth: 260,
        },
        {
            Header: "Seller ID",
            accessor: "sellerID",
            minWidth: 170,
        },
        {
          Header: "Notification Payload",
          accessor: "notificationPayload",
          minWidth: 380,
          Cell: ({ value, index }) => {
      
              const cellKey = `payload-${index}`;
              const isExpanded = expandedPayload[cellKey];
      
              const payload =
                  typeof value === "object"
                      ? JSON.stringify(value, null, 2)
                      : String(value || "");
      
              const showButton = payload.length > 150;
      
              return (
                  <div className="d-flex flex-column">
      
                      <div
                          style={{
                              whiteSpace: "pre-wrap",
                              wordBreak: "break-word",
                              maxHeight: isExpanded ? "none" : "80px",
                              overflow: "hidden",
                          }}
                      >
                          {payload}
                      </div>
      
                      {showButton && (
                          <span
                              style={{
                                  color: "#3D85C6",
                                  cursor: "pointer",
                                  fontSize: "11px",
                                  fontWeight: "bold",
                                  marginTop: "4px",
                              }}
                              onClick={() =>
                                  setExpandedPayload((prev) => ({
                                      ...prev,
                                      [cellKey]: !prev[cellKey],
                                  }))
                              }
                          >
                              {isExpanded ? "Read Less" : "...Read More"}
                          </span>
                      )}
                  </div>
              );
          },
      },
        {
            Header: "Payload Version",
            accessor: "payload_version",
            width: 100,
        },
        {
            Header: "Created At",
            accessor: "CreatedAt",
            minWidth: 150,
        },
        {
          Header: "Event Time",
          accessor: "eventTime",
          minWidth: 180,
          Cell: ({ value }) => {
              if (!value) return "-";
      
              const date = new Date(value);
      
              return `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`;
          }
      }
    ];

    return (
        <div className="proactive-monitoring-page">

            <Row className="mt-3 mb-3">
                <Col>
                    <Card className="mb-2">
                        <CardTitle className="border rounded mb-0 p-2 notification-status-title d-flex align-items-center">

                            <button
                                className="back-button-header"
                                onClick={props.onBackHeader}
                                style={{
                                    padding: 0,
                                    border: "none",
                                    background: "transparent",
                                }}
                            >
                                <img src={BackButton} alt="Back" />
                            </button>

                            <div className="flex-grow-1 text-center">
                                Amazon Notifications
                            </div>

                        </CardTitle>
                    </Card>
                </Col>
            </Row>
            <Row className="mb-2 justify-content-end">
                <Col md={4}>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Search Amazon Notifications..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                </Col>
            </Row>
            <Row>
                <Col md={12}>
                <ReactTable
                      data={filteredNotificationData}
                      columns={columns}
                      className="-fixed -highlight -striped"
                      getTheadProps={() => ({
                          style: {
                              overflowY: "hidden",
                              background: "#B1FA63",
                              color: "#243837",
                          },
                      })}
                      defaultPageSize={12}
                      noDataText="No Data Found."
                  />
                </Col>
            </Row>

        </div>
    );
}

const mapStateToProps = state => ({
  token: state.loggedUser.token,
});

export default connect(mapStateToProps)(AmazonNotificationsMainPage);